import { GamoraUUIDGuard } from '@ver.id/libs.internal.gamora';
import { HoruzError } from '../../../../index.js';
import { HoruzProtocolChulakServiceSessionGuardTags } from '../../guards/service-session.js';
import { HoruzProtocolChulakServiceSessionGuardUpdatedTagsType } from '../../guards/message/app-tags-refreshed.js';

/**
 * List of invokers
 * @public
 */
export enum HoruzProtocolChulakClientStateInvoker {
  CreateAuthentication = 'CreateAuthentication',
  CompletedAuthentication = 'CompletedAuthentication',
  RefreshedAppTags = 'RefreshedAppTags',
  CompletedAgentStart = 'CompletedAgentStart',
  VerifyAppPairing = 'VerifyAppPairing',
  WaitingForPresentation = 'WaitingForPresentation',
  CompletedPresentation = 'CompletedPresentation',
}

/**
 * List of events
 * @public
 */
export enum HoruzProtocolChulakClientStateEvent {
  Aborted = 'Aborted',
  Done = 'Done',
}

/**
 * @public
 */
export interface HoruzProtocolChulakClientStateInvokerCompletedAuthenticationInput {
  serviceSessionUuid: GamoraUUIDGuard;
  tags: HoruzProtocolChulakServiceSessionGuardTags;
}

/**
 * @public
 */
export interface HoruzProtocolChulakClientStateInvokerAppTagsRefreshedInput {
  tags: HoruzProtocolChulakServiceSessionGuardUpdatedTagsType;
}

/**
 * @public
 */
export interface HoruzProtocolChulakClientStateInvokerVerifyAppPairingInput {
  method: 'pin';
  code: string;
}

/**
 * @public
 */
export interface HoruzProtocolChulakClientStateInvokerAbortInput {
  error?: HoruzError;
}

/**
 * @public
 */
export interface HoruzProtocolChulakClientStateInvokerStartInput {}

/**
 * @public
 */
export interface HoruzProtocolChulakClientStateInvokerCompletedPresentationInput {
  // The presentation token in compact format
  compact: string;
}

/**
 * @public
 */
export interface HoruzProtocolChulakClientStateInvokerWaitingForPresentationInput {}

/**
 * @public
 */
export type HoruzProtocolChulakClientStateInvokerCreateAuthenticationResult = {
  // The authentication token in compact format
  compact: string;
  fresh?: boolean;
};

/**
 * List of yielders
 * @public
 */
export enum HoruzProtocolChulakClientStateYielder {
  CompletedAppPairing = 'CompletedAppPairing',
}

/**
 * @public
 */
export interface HoruzProtocolChulakClientStateYielderCompletedAppPairingInput {}
